import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const GlobalGroupIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "GlobalGroup",
    children: /*#__PURE__*/_jsx("path", {
      d: "M28.01 21.09c.35-1.1.55-2.36.55-3.67 0-5.57-3.62-10.29-8.64-11.94l-.09-.02C19.62 3.51 17.98 2 15.99 2s-3.63 1.51-3.84 3.44v.02c-5.11 1.67-8.73 6.39-8.73 11.96 0 1.31.2 2.57.57 3.76l-.02-.09c-.76.71-1.23 1.71-1.23 2.83 0 2.14 1.73 3.87 3.87 3.87.63 0 1.23-.15 1.76-.42h-.02C10.44 29.02 13.1 30 15.99 30s5.56-.99 7.67-2.65l-.03.02c.51.27 1.1.43 1.74.44h.02c2.14 0 3.87-1.73 3.87-3.87 0-1.13-.48-2.14-1.25-2.85M9.9 26a3.8 3.8 0 0 0 .58-2.04c0-2.14-1.73-3.87-3.87-3.87H6.6c-.26 0-.52.03-.77.08h.02a10.416 10.416 0 0 1 6.55-12.6l.07-.02c.63 1.33 1.96 2.24 3.5 2.24s2.87-.9 3.49-2.21v-.02c4.12 1.46 7 5.32 7 9.84 0 .97-.13 1.92-.38 2.81l.02-.07c-.22-.05-.48-.07-.75-.07-2.14 0-3.87 1.73-3.87 3.87v.05c0 .75.22 1.46.59 2.05v-.02c-1.7 1.23-3.81 1.96-6.1 1.96s-4.4-.74-6.12-1.98l.03.02Z"
    })
  }));
};